var caseStudyFrame = function() {

    var exam = $.parseHTML(
        '<div class="exam row">' +
            '<div class="row question-row">' +
                '<div class="history col-lg-12">' +
                '</div>' +
                '<div class="question col-lg-12">' +
                '</div>' +
            '</div>' +
            '<div class="row choices-row">' +
                '<div class="choices col-lg-9 col-md-9">' +
                    '<div class="list-group"></div>' +
                '</div>' +
                '<div class="col-lg-3 col-md-3 choices-right">' +
                '<div class="row">' +
                '<div class="col-lg-12 col-md-12"><span class="current-index"></span>' +
                '</div>' +
                '<div class="col-lg-12 col-md-12">' +
                '<ul class="image-list">' +
                '</ul>' +
                '</div>' +
                '</div>' +
                '</div>' +
            '</div>' +
            '<div class="row">' +
                '<div class="col-lg-10 col-md-10"><button id="show-answer" class="btn btn-default">Show Answer</button></div>' +
            '</div>' +
            '<div class="row nav-row">' +
                '<div class="col-lg-2 col-md-2 question-nav">' +
                    '<div class="btn-group">' +
                        '<button class="btn btn-default previous" disabled="disabled"><span class="glyphicon glyphicon-chevron-left"></span></button>' +
                        '<button class="btn btn-default next"><span class="glyphicon glyphicon-chevron-right"></span></button>' +
                    '</div>' +
                '</div>' +
                '<div class="col-lg-6 col-md-6 progress-nav">' +
                    '<div class="progress"><div class="progress-bar" role="progressbar" aria-valuenow="" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div>' +
                '</div>' +
                '<div class="col-lg-4 col-md-4 save-nav">' +
                    '<div class="btn-group">' +
                        '<button class="btn btn-default" type="button" id="finish">Finish</button>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>');


    return exam;
}

module.exports = caseStudyFrame;


//////////////////
// WEBPACK FOOTER
// ./src/casestudy_frame.js
// module id = 294
// module chunks = 0